<template>
  <div>
    <wc-data-box
      title='Misc Settings'
      :loading='isLoading'
      showEdit
      @edit='editSettings'
    >
      <wc-two-column-table
        @rowClick='editSettings'
        :items='miscData'
        ></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      title='Misc Settings'
      :showDialog='showDialog'
      :loading='isSaving'
      :disableButtons='isSaving'
      @cancel='showDialog = false'
      @save='save'
      width='400'
    >
      <v-form v-model='isFormValid'>
        <v-row>
          <v-col>
            <v-text-field
              label='Tax rate'
              v-model='settingsCopy.tax_rate'
              append-icon='mdi-percent'
              :rules='[rules.decimal]'
            ></v-text-field>
          </v-col>
          <v-col>
            <v-select
              :items='increment_options'
              v-model='settingsCopy.timesheet_increment'
              label='Timesheet increment'
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              :items='months'
              v-model='settingsCopy.yearend_month'
              label='Yearend Month'
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import settingsAPI from '../../api/settings'
// import budgetsAPI from '@/modules/management/api/budgets'
import _ from 'lodash'

export default {
  name: 'misc-settings',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    showDialog: false,
    settings: null,
    settingsCopy: {},
    budgets: [],
    activeBudget: null,
    selectedBudget: null,
    increment_options: [1,5,10,15,30]
  }),
  computed: {
    months () {
      return [
        { text: 'January', value: 1 },
        { text: 'February', value: 2 },
        { text: 'March', value: 3 },
        { text: 'April', value: 4 },
        { text: 'May', value: 5 },
        { text: 'June', value: 6 },
        { text: 'July', value: 7 },
        { text: 'August', value: 8 },
        { text: 'September', value: 9 },
        { text: 'October', value: 10 },
        { text: 'November', value: 11 },
        { text: 'December', value: 12 },
      ]
    },
    miscData () {
      if (this.settings) {
        return [
          { text: 'Tax rate', value: this.settings.tax_rate + '%' },
          { text: 'Timesheet increment', value: this.settings.timesheet_increment + ' mins.' },
          { text: 'Yearend month', value: _.find(this.months, m => m.value === this.settings.yearend_month).text }
        ]
      }
      return []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.settings = await settingsAPI.getSettings()
      // this.activeBudget = await budgetsAPI.getActiveBudget()
      // this.budgets = await budgetsAPI.getBudgets()
      this.isLoading = false
    },
    editSettings () {
      this.settingsCopy = _.cloneDeep(this.settings)
      // this.selectedBudget = _.cloneDeep(this.activeBudget)
      this.showDialog = true
    },
    async save () {
      this.isSaving = true
      this.settings = await settingsAPI.updateSettings(this.settingsCopy)
      // this.selectedBudget.is_active = true
      // this.activeBudget = await budgetsAPI.updateBudget(this.selectedBudget)
      // this.budgets = await budgetsAPI.getBudgets()
      this.showDialog = false
      this.isSaving = false
    }
  }
}
</script>
